
export default {
  name: 'ContentProducts',

  components: {
    Pagination: () => import('~/components/UI/Pagination.vue'),
  },

  props: {
    tableOptions: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
    totalProducts: {
      type: String,
      default: '',
    },
    totalPages: {
      type: [String, Number],
      default: 0,
    },
    sort: {
      type: String,
      default: '',
    },

    isLoadProducts: {
      type: Boolean,
      default: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    isHover: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    parseTableValue(item, product) {
      if (item.type === 'image') {
        const imageUrl = this.$img(String(product.imageId), {
          width: 80,
          height: 80,
          fit: 'contain',
          loading: 'lazy',
        });
        return `<img src="${imageUrl}" width="80" height="80" loading="lazy" style="object-fit: contain"/>`;
      }
      if (item.fieldName && item.type === 'number') {
        return this.$numberFormat(product[item.fieldName]);
      }
      if (item.fieldName) {
        return product[item.fieldName];
      }
      if (item.charName && item.type === 'number') {
        // смотрим цену за метр со скидкой из характеристик
        const salePrice = (product?.shortCharacteristics || []).find((t) => t?.slug === 'cena-za-m-sale')?.values?.[0]?.value;

        let value = '';
        if (item.charName === 'cena-za-m' && salePrice)
          value = salePrice;
        // если нет скидки за метр, то показываем без
        else if (!salePrice) {
          value = (product?.shortCharacteristics || []).find((t) => t.slug === item.charName)?.values?.[0]?.value;
        }
        if (!value) {
          return 'N/A';
        }

        return this.$numberFormat(value);
      }
      if (item.charName) {
        return (product?.shortCharacteristics || []).find((t) => t.slug === item.charName)?.values?.[0]?.value || 'N/A';
      }

      return 'N/A';
    },

    clickRow(product) {
      if (!this.isHover) {
        return;
      }

      this.$emit('clickRow', product);
    },
    actionClick(product, event) {
      event.stopPropagation();
      this.$emit('actionClick', product);
    },

    onChangePage(page) {
      const headerHeight = document.querySelector('header')
        .getBoundingClientRect().height;
      const tableTopPosition = document.body.scrollTop + this.$refs.recContentProducts.getBoundingClientRect().top;
      const newScrollPosition = tableTopPosition - headerHeight - 30 + window.scrollY;

      window.scrollTo({
        top: newScrollPosition,
      });
      this.$emit('onChangePage', page);
    },
    onChangeSort(name) {
      const isRevert = Boolean(this.sort?.[0] === '-');
      const currentSortName = isRevert ? (this.sort || '').slice(1) : this.sort;
      const active = Boolean(currentSortName === name);

      let newSort = name;
      if (!isRevert) {
        newSort = `-${newSort}`;
      }

      this.$emit('onChangeSort', newSort);
    },

    _sortClassHead(name) {
      const isRevert = Boolean(this.sort?.[0] === '-');
      const currentSortName = isRevert ? (this.sort || '').slice(1) : this.sort;
      const active = Boolean(currentSortName === name);
      if (!active) {
        return '';
      }

      const items = [];
      if (active) {
        items.push('--active');
      }
      if (!isRevert) {
        items.push('--revert');
      }

      return items.join(' ');
    },
  },
};
